export default class TextImgAnchor {
    static init(): void {
      interface TextImgAnchorElement extends HTMLElement {
          dataset: {
            anchor: string;
          };
        }
        
        // Funkce pro hladký scroll na sekci
        const smoothScrollToSection = (id: string): void => {
          const targetSection = document.getElementById(id);
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            console.warn(`Section with ID '${id}' not found.`);
          }
        };
        
        // Funkce pro aktualizaci aktivní třídy na základě pozice sekcí
        const updateActiveClass = (): void => {
          const anchorsContainer = document.querySelector('.text-img-anchor');
          if (!anchorsContainer) return;
        
          const anchors = anchorsContainer.querySelectorAll<TextImgAnchorElement>('[data-anchor]');
          const sections = Array.from(document.querySelectorAll<HTMLElement>('[id]'));
        
          let activeId: string | null = null;

          const tolerance = 5; // Tolerance v pixelech
        
          // Najít aktuální sekci podle její pozice na stránce
          for (const section of sections) {
            const rect = section.getBoundingClientRect();
            const sectionTop = rect.top + window.scrollY - tolerance;
            const sectionHeight = rect.height;
        
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
              activeId = section.id;
              break;
            }
          }
        
          // Aktualizovat třídy na kotvách
          anchors.forEach((anchor) => {
            const targetId = anchor.dataset.anchor;
            if (targetId === activeId) {
              anchor.classList.add('is-active');
            } else {
              anchor.classList.remove('is-active');
            }
          });
        };
        
        // Funkce pro aktualizaci pozice .text-img-anchor
        const updateAnchorPosition = (): void => {
          const contentContainer = document.querySelector('.text-img-section__content') as HTMLElement | null;
          const anchorContainer = document.querySelector('.text-img-anchor') as HTMLElement | null;
        
          if (!contentContainer || !anchorContainer) return;
        
          const contentRect = contentContainer.getBoundingClientRect();
          const contentTop = contentRect.top + window.scrollY;
          const contentBottom = contentTop + contentRect.height;
        
          const anchorHeight = anchorContainer.offsetHeight; // Nyní TypeScript ví, že anchorContainer je HTMLElement
        
          // Odstranit všechny třídy
          anchorContainer.classList.remove('is-fixed', 'is-bottom');
        
          // Přidat třídu is-fixed, pokud je obsah na horní hraně obrazovky
          if (window.scrollY >= contentTop && window.scrollY + anchorHeight < contentBottom) {
            anchorContainer.classList.add('is-fixed');
          }
        
          // Přidat třídu is-bottom, pokud jsme na konci obsahu
          if (window.scrollY + anchorHeight >= contentBottom) {
            anchorContainer.classList.add('is-bottom');
          }
        };
        
        
        // Inicializace kotvových odkazů
        const initializeAnchors = (): void => {
          const anchorsContainer = document.querySelector('.text-img-anchor');
          if (!anchorsContainer) return;
        
          const anchors = anchorsContainer.querySelectorAll<TextImgAnchorElement>('[data-anchor]');
        
          anchors.forEach((anchor) => {
            const targetId = anchor.dataset.anchor;
        
            if (targetId) {
              anchor.addEventListener('click', (event) => {
                event.preventDefault();
                smoothScrollToSection(targetId);
              });
            }
          });
        
          // Připojení aktualizace při scrollování
          window.addEventListener('scroll', updateActiveClass);
        
          // Spuštění na načtení stránky
          updateActiveClass();
        };
        
        // Inicializace pozice kotvy
        const initializeAnchorPositioning = (): void => {
          // Aktualizovat pozici při scrollování
          window.addEventListener('scroll', updateAnchorPosition);
        
          // Spuštění na načtení stránky
          updateAnchorPosition();
        };
        
        // Spuštění všech funkcí po načtení DOM
        initializeAnchors(); // Původní kotvy
        initializeAnchorPositioning(); // Fixní a dolní stav kotvy
          
    }
}